import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
function trackClickedSeeAllReviews({ parkingSpotId, parkingSpotName, starRating, count, }) {
    try {
        const properties = {
            parking_spot_id: parkingSpotId,
            parking_spot_name: parkingSpotName,
            star_rating: {
                average: starRating,
                count,
            },
        };
        SegmentUtils.track({
            event: 'Clicked See All Reviews',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - trackClickedSeeAllReviews',
        });
    }
}
export default trackClickedSeeAllReviews;
